export default "__VITE_ASSET__BPPT0II7__"